import { configureStore } from '@reduxjs/toolkit'
import plaginFnReducer from './services/plaginFn'

export default configureStore({
  reducer: {
    pluginFn: plaginFnReducer,
  },
})